<template>
  <div class="c-report-files">
    <div
      v-for="(item) in data"
      :key="item.key"
    >
      <c-report-row
        :data="item"
      />
    </div>
  </div>
</template>

<script>
import CReportRow from './CReportRow.vue'

export default {
  name: 'CReportFiles',
  components: {
    CReportRow
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  }
}
</script>
